import type { AuditActionsFetchedAction } from '@Application/AuditTrail/Actions/auditActionsFetched';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type AuditActionsStore = {
	auditActions: readonly LabeledValueView[] | null;
};

const initialState: AuditActionsStore = {
	auditActions: null,
};

type Actions = AuditActionsFetchedAction | UserRevokedAction;

const whenAuditActionsFetched = (
	store: AuditActionsStore,
	action: AuditActionsFetchedAction,
): AuditActionsStore => ({
	...store,
	auditActions: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): AuditActionsStore => initialState;

export default registerStore<'auditActionsStore', Actions>(
	'auditActionsStore',
	createSliceReducer({
		AUDIT_ACTIONS_FETCHED: whenAuditActionsFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
